<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Customize {{params.line_type}} {{params.value_type}}</v-card-title>

        <v-card-text>
            <div
                v-if="params.instructions == null"
                style="margin-bottom: 15px"
            >
                The default value from the "{{params.rate_card_label}}"" rate card is <span style="font-family: monospace;">{{pretty_default_value}}</span>
            </div>
            <div
                v-else
            >
                {{params.instructions}}
            </div>


            <v-text-field
                :label="field_label"
                v-model="params.effective_value"
                autofocus
                @keydown.enter="$event.preventDefault(); onOk();"
                autocomplete="off"
            />

            If saved, the value would be: <span style="font-family: monospace; font-size: 20px">{{hint}}</span>
        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                @click="onDefault"
                v-if="params.default_value != null"
            >
            Return to Default
            </v-btn>

            <v-spacer></v-spacer>


            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>


const Millicents = require('@/js/millicents.js');

export default {

    data() {
        return {
            dialog: false,
            params: {
                'line_type' : 'subscription',
                'value_type' : 'setup_fee',
                'default_value' : '0',
                'effective_value' : 200000,
                'rate_card_label' : 'Solopreneur',
            },
        }
    },

    methods: {

        showDialog(params)
        {
            this.params = params;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            let val = parseInt(this.params.effective_value);
            this.params.on_edit(val);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onDefault()
        {
            this.dialog = false;
            this.params.on_edit(null);
        }

    },

    computed: {
        pretty_default_value() {
            if ( this.params.value_type == 'milli_percent' )
                return Millicents.prettyPrintMillipercent(this.params.default_value);

            if ( this.params.value_type != 'included_count' )
                return Millicents.prettyPrint(this.params.default_value);
            
            return this.params.default_value.toLocaleString();
        },

        field_label() {
            if ( this.params.value_type == 'included_count' )
                return 'Custom count to include';
            
            if ( this.params.value_type == 'setup_fee' )
                return 'Custom setup fee (enter millicents)';

            if ( this.params.value_type == 'fee' )
                return 'Custom fee (enter millicents)';
            
            return '';
        },

        hint() 
        {
            let val = parseInt(this.params.effective_value);
            let isnum = /^\d+$/.test(this.params.effective_value);

            if ( isNaN(val) || !isnum )
                return 'Enter a number';

            if ( this.params.value_type == 'milli_percent' )
                return Millicents.prettyPrintMillipercent(val);

            if ( this.params.value_type == 'included_count' ) 
                return val.toLocaleString();

            return Millicents.prettyPrint(val);
        },

        is_valid()
        {
            let val = parseInt(this.params.effective_value);
            let isnum = /^\d+$/.test(this.params.effective_value);

            if ( isNaN(val) || !isnum )
                return false;

            return true;
        }   
    },
}
</script>

<style lang="scss" scoped>
</style>